import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Campaign from '../models/Campaign';
import MarkupBundle from './../models/MarkupBundle';
import Urls from './../api/Urls';

export function getCampaigns(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_LIST,
        params: params,
        parser: campaignsDataParser,
    }).get();
}

export function getCampaignDetail(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_DETAIL,
        endpointParams: { id },
        parser: data => {
          const mappedData = {
            ...data,
            IsExtendPromotion: data.isExtendPromotion,
            ExPromotionMemberShipTypes: data.exPromotionMemberShipTypes,
            ExEmailSuffix: data.exEmailSuffix,
            ExPromotionEmails: data.exPromotionEmails,
            ExObjectType: data.exObjectType,
          }
          const result = new Campaign(mappedData)
          return result
        },
    }).get();
}

export function createCampaign(campaign) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_CREATE,
    }).post(campaign.export());
}

export function updateCampaign(campaign) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_UPDATE,
    }).put(campaign.export());
}

export function getMarkupPromotionConfig(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.CAMPAIGN_MARKUP_CONFIG,
        params: params,
        parser: (data) => (data.data || []).map(item => new MarkupBundle(item)),
    }).get();
}

export function getMarkupPromotionFly() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.CAMPAIGN_MARKUP_FLY,
        parser: (data) => (data.data || [])
    }).get();
}

export function getMarkupBundleMinValue(data) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.PROMOTION_GET_FILE_SAMPLE,
        parser: (data) => (data || null)
    }).post(data);
}

// export function createCampaignTranslate(campaign) {
//     return new ApiService({
//         baseURL: Config.API_PROMOTION,
//         endpoint: Urls.CAMPAIGN_TRANSLATE_CREATE,
//     }).post(campaign.export(true).translate());
// }
export function createCampaignTranslate(campaign) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_TRANSLATE_CREATE,
    }).post(campaign);
}

export function updateCampaignTranslate(campaign) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_TRANSLATE_UPDATE,
    }).put(campaign);
}

export function deleteCampaign(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_DETAIL,
        endpointParams: { id },
    }).delete();
}

export function cloneCampaign(campaign) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_CLONE,
    }).post(campaign);
}

export function getCountries() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_COUNTRIES_LIST
    }).get();
}

export function getChannels() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_CHANNELS_LIST
    }).get();
}

export function getPromotionBanks() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_BANK_LIST
    }).get();
}

export function parseExcel(formData) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CAMPAIGN_PARSE_EXCEL,
    }).post(formData);
}


const campaignsDataParser = (data) => ({
    result: (data.result || []).map(item => new Campaign(item)),
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalCount
})
